const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const TIMEZONES = [...new Set(['UTC', detected, ...(Intl.supportedValuesOf ? Intl.supportedValuesOf('timeZone') : [])])].sort();
export const PortalTimezoneSelect = ({ value, onChange, testId }) => <label className="portal-field">Time zone
  <select value={value} onChange={e => onChange(e.target.value)} data-testid={testId} className="portal-native-select">
    {TIMEZONES.map(zone => <option value={zone} key={zone}>{zone.replaceAll('_', ' ')}</option>)}
  </select>
</label>;